import {Box, Stack, styled} from "@mui/material"
import React, {useContext, useEffect, useRef} from "react"
import Content from "../../components/Content"
import {evaluateFullHeight} from "../../misc/utils"
import {DataContext} from "../../../src/context/DataContextProvider"
import {ActionContext} from "../../../src/context/ActionContextProvider"

export const containerPagePrototype = [
    {
        key: "path",
        type: "STRING",
        label: "Pfad",
        size: 6,
    }
]

const PageBox = styled(Box)(({theme}) => theme.PAGE.box)

const ContainerPage = ({container, triggerAction}) => {
    const {action, containerSpacing = 16 ,fullHeight} = container
    const ref = useRef(null)
    const {getDataFromPointer} = useContext(DataContext)
    const {sendDataToBackend} = useContext(ActionContext)
    useEffect(() => {
            action && triggerAction(action)
            triggerAction("DEFAULT_PAGE_INIT")
    }, [])
    return (
        <Stack minHeight={evaluateFullHeight(fullHeight)} >
            {container.children?.map((child) => (
                <Content
                    key={child.id}
                    child={child}
                    ref={ref}
                    wrapper={(children) => (
                        <PageBox
                            bgcolor="background.paper"
                            minHeight={evaluateFullHeight(child.fullHeight)}
                        >
                            {children}
                        </PageBox>
                    )}
                />
            ))}
        </Stack>
    )
}

export default ContainerPage
